import { Close } from '@mui/icons-material';
import { CircularProgress, IconButton, Paper, Stack, Typography } from '@mui/material';
import { addGeofenceCheckedId, setFilterTab } from 'app/actions/map';
import { MapTransportTaskList } from 'app/pages/Map';
import { hasTransportTask } from 'app/pages/Map/MapTransportTaskList';
import { useAsyncAction } from 'app/services';
import { transportTaskLoad } from 'app/store/map';
import React, { useEffect, useMemo, useState } from 'react';
import { Popup } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
const MapLeafletTransportPopup = (props) => {
    const dispatch = useDispatch();
    const { value, onClose } = props;
    const { ref: mapRef, filterTab, geofenceCheckedId } = useSelector((state) => state.map);
    const [open, setOpen] = useState(false);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportTaskLoad);
    const maxWidth = useMemo(() => {
        return config.mapTransportTaskColumns.reduce((accumulator, column) => accumulator + column.width, 24);
    }, []);
    const handleItemColumnClick = (value) => {
        var _a, _b, _c, _d;
        if (geofenceCheckedId.indexOf(value.geofence_id) === -1) {
            dispatch(addGeofenceCheckedId(value.geofence_id));
        }
        if (filterTab !== 'geofence') {
            dispatch(setFilterTab('geofence'));
        }
        (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [value.latitude, value.longitude]);
    };
    const handleCloseClick = () => {
        onClose();
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    useEffect(() => {
        if (open) {
            fetchData(value.id);
        }
    }, [open]);
    return (React.createElement(Popup, Object.assign({ className: 'leaflet-popup-transport', onOpen: handleOpen }, config.mapPopupOptions, { maxWidth: maxWidth }),
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                fontSize: '12px',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                borderRadius: theme.shape.borderRadius,
            }) },
            React.createElement(Stack, { direction: 'row', alignItems: 'center', justifyContent: 'center', sx: {
                    padding: '10px 0',
                    bgcolor: 'background.default',
                    minHeight: '44px',
                    '.MuiTypography-root': {
                        whiteSpace: 'nowrap',
                        margin: '0 1px',
                        width: '100%',
                        padding: '0 50px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        textAlign: 'center',
                        fontSize: '13px',
                    },
                } },
                React.createElement(Typography, { variant: 'body1' }, value.name),
                React.createElement(Stack, { direction: 'row', alignItems: 'center', component: 'ul', sx: (theme) => ({
                        position: 'absolute',
                        right: '8px',
                        top: '7px',
                        margin: '0',
                        marginLeft: 'auto',
                        listStyle: 'none',
                        li: {
                            margin: '0',
                            padding: '0',
                            display: 'flex',
                            alignItems: 'center',
                            button: {
                                width: '30px',
                                height: '30px',
                                '.maximizeIcon, .minimizeIcon': {
                                    width: '16px',
                                    height: '16px',
                                },
                            },
                        },
                        'li:not(:last-of-type) path': {
                            fill: theme.palette.text.secondary,
                        },
                    }) },
                    React.createElement("li", null,
                        React.createElement(IconButton, { className: 'leaflet-popup-close-button', color: 'default', onClick: handleCloseClick },
                            React.createElement(Close, { fontSize: 'small' }))))),
            React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                    padding: theme.spacing(2),
                }) },
                !isFetchLoading && hasTransportTask(value) && (React.createElement(React.Fragment, null,
                    React.createElement(Stack, { direction: 'row', sx: (theme) => ({
                            display: 'grid',
                            gap: 2,
                            marginBottom: theme.spacing(1),
                            '.MuiPaper-root': {
                                position: 'relative',
                                border: 'none',
                                display: 'grid',
                                gap: '6px',
                                gridTemplateColumns: 'repeat(2, 1fr)',
                            },
                            '.MuiPaper-row': {
                                display: 'grid',
                                gap: 1,
                                gridTemplateColumns: 'repeat(6, 1fr)',
                                '.MuiTypography-root:first-of-type': {
                                    color: 'text.secondary',
                                },
                            },
                            '.MuiPaper-row .MuiTypography-root:first-of-type': {
                                gridRow: '1',
                                gridColumn: '1/4',
                            },
                            '.MuiPaper-row .MuiTypography-root:last-of-type': {
                                gridRow: '1',
                                gridColumn: '4/7',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                'span:nth-of-type(2)': {
                                    paddingLeft: theme.spacing(0.5),
                                },
                            },
                        }) },
                        React.createElement(Paper, { variant: 'outlined' },
                            React.createElement(Stack, { className: 'MuiPaper-column' },
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                    React.createElement(Typography, { variant: 'body1' }, value.task.id)),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0434\u0430\u043D\u0438\u044F"),
                                    React.createElement(Typography, { variant: 'body1' }, {
                                        finished: 'Завершено',
                                        active: 'Активно',
                                    }[value.task.status]))),
                            React.createElement(Stack, { className: 'MuiPaper-column' },
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430"),
                                    React.createElement(Typography, { variant: 'body1' }, moment(value.task.task_date).format('DD.MM.YYYY HH:mm:ss'))),
                                React.createElement(Stack, { className: 'MuiPaper-row' },
                                    React.createElement(Typography, { variant: 'body1' }, "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F"),
                                    React.createElement(Typography, { variant: 'body1' }, moment(value.task.finished_date).isValid() && moment(value.task.finished_date).format('DD.MM.YYYY HH:mm:ss')))))),
                    React.createElement(MapTransportTaskList, { value: value, onItemColumnClick: handleItemColumnClick }))),
                !isFetchLoading && !value.task && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                        '.MuiTypography-root': {
                            textAlign: 'center',
                        },
                    }) },
                    React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                    React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u0412 \u044D\u0442\u043E\u043C \u0440\u0430\u0437\u0434\u0435\u043B\u0435 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0437\u0430\u0434\u0430\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430"))),
                isFetchLoading && (React.createElement(Stack, { direction: 'row', justifyContent: 'center', sx: (theme) => ({
                        width: '100%',
                        height: '100%',
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(CircularProgress, { size: 18 })))))));
};
export default MapLeafletTransportPopup;
